// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 53 ? "5e3fcbca" : chunkId) + "." + {"53":"fd48d16b37acb724","691":"0f4ac3b720980d08"}[chunkId] + ".js";
};